// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Firebase configuration - uses environment variables for production
// Set these in your .env.production file or Firebase Hosting environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCT8bOenyeYFK4CCquareuvokpuQl8DS_s",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "upsanddownsapp-6a548.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "upsanddownsapp-6a548",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "upsanddownsapp-6a548.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "575310388987",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:575310388987:web:7c73da47ece4926ced9a5e"
};

// Log Firebase configuration (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('🔥 Firebase Configuration:', {
    projectId: firebaseConfig.projectId,
    authDomain: firebaseConfig.authDomain,
    usingEnvVars: {
      apiKey: !!process.env.REACT_APP_FIREBASE_API_KEY,
      projectId: !!process.env.REACT_APP_FIREBASE_PROJECT_ID,
      authDomain: !!process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
    }
  });
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Functions and get a reference to the service
const functions = getFunctions(app);

// Create callable functions
const createPaymentIntentCallable = httpsCallable(functions, "createPaymentIntent");
const createCheckoutSessionCallable = httpsCallable(functions, "createCheckoutSession");
const createCustomerPortalSessionCallable = httpsCallable(functions, "createCustomerPortalSession");
const verifySubscriptionStatusCallable = httpsCallable(functions, "verifySubscriptionStatus");
const syncSubscriptionStatusCallable = httpsCallable(functions, "syncSubscriptionStatus");
const sendFollowUpReminderEmailCallable = httpsCallable(functions, "sendFollowUpReminderEmail");
const personalizeFriendshipJourneyCallable = httpsCallable(
    functions,
    "personalizeFriendshipJourney",
);

// Export function to create PaymentIntent
export async function createPaymentIntent(amount) {
  const result = await createPaymentIntentCallable({ amount });
  return result.data.clientSecret;
}

// Export function to create Checkout Session
export async function createCheckoutSession(amount, successUrl, cancelUrl) {
  const result = await createCheckoutSessionCallable({
    amount,
    successUrl,
    cancelUrl
  });
  return result.data;
}

// Export function to create Customer Portal session
export async function createCustomerPortalSession(returnUrl) {
  const result = await createCustomerPortalSessionCallable({
    returnUrl
  });
  return result.data;
}

// Export function to verify subscription status
export async function verifySubscriptionStatus(sessionId) {
  const result = await verifySubscriptionStatusCallable({
    sessionId
  });
  return result.data;
}

// Export function to sync subscription status from customer ID
export async function syncSubscriptionStatus() {
  const result = await syncSubscriptionStatusCallable({});
  return result.data;
}

// Export function to send follow-up reminder email
export async function sendFollowUpReminderEmail(reminderPayload) {
  const result = await sendFollowUpReminderEmailCallable(reminderPayload);
  return result.data;
}

/**
 * @param {{ reflectionAnswers: object, locale?: string, friendName?: string }} payload
 * @return {Promise<{ personalization: object }>}
 */
export async function personalizeFriendshipJourney(payload) {
  const result = await personalizeFriendshipJourneyCallable(payload);
  return result.data;
}

export default app;